import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';

const ConsentBrandHeader = ({ logoUrl, practiceName, primaryColor, theme }) => {
    const dividerEnabled = theme?.brandDividerEnabled !== false;
    const dividerColor = theme?.brandDividerColor || primaryColor || theme?.primaryColor || '#00AB55';
    const dividerWidth = theme?.brandDividerWidth || 2;

    return (
    <Box sx={{
        textAlign: theme?.brandLogoAlignment || 'center',
        pb: 3,
        mb: 3,
        ...(dividerEnabled ? { borderBottom: `${dividerWidth}px solid ${dividerColor}` } : {}),
    }}>
        {logoUrl && (
            <Box
                component="img"
                src={logoUrl}
                alt={practiceName || 'Practice Logo'}
                sx={{
                    height: theme?.brandLogoHeight || 60,
                    maxWidth: '100%',
                    mb: 1.5,
                    objectFit: 'contain',
                }}
            />
        )}
        {practiceName && (theme?.showPracticeName !== false) && (
            <Typography sx={{
                fontSize: theme?.practiceNameFontSize || '1.5rem',
                fontWeight: 700,
                color: theme?.headingColor || '#212B36',
                fontFamily: theme?.headingFontFamily || theme?.fontFamily || 'inherit',
            }}>
                {practiceName}
            </Typography>
        )}
    </Box>
    );
};

ConsentBrandHeader.propTypes = {
    logoUrl: PropTypes.string,
    practiceName: PropTypes.string,
    primaryColor: PropTypes.string,
    theme: PropTypes.object,
};

ConsentBrandHeader.defaultProps = {
    logoUrl: '',
    practiceName: '',
    primaryColor: '#00AB55',
    theme: null,
};

export default ConsentBrandHeader;
